(ns io.daskul.webapp.render-flush
  "Keeps re-frame subscription updates flowing while the tab is hidden.

   Reagent batches reactive re-renders on requestAnimationFrame, which
   browsers suspend for hidden/occluded tabs. Re-frame events still run
   there (their queue drains via goog.async.nextTick), so app-db keeps
   changing while the UI stays frozen at its last painted state — a deep
   link loaded in a background window boots to a blank page until the tab
   becomes visible or something else re-renders.

   Full write-up, evidence, and alternatives considered:
   docs/ui/hidden-tab-rendering.md (SMS-179)."
  (:require
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn install!
  "Register a re-frame post-event callback that synchronously flushes
   reagent's render queue whenever an event is processed while the
   document is not visible. No-op for visible tabs (normal rAF batching
   applies). Call once from app init, before the first dispatch."
  []
  (rf/add-post-event-callback ::flush-when-hidden
    (fn [_event _queue]
      (when (= "hidden" (.-visibilityState js/document))
        (r/flush)))))
